import {Stack, Typography, useTheme} from '@mui/material';
import React from 'react';
import Icon from 'presentation/icons';
import {translations} from 'presentation/translations-new';
import {ReadOnlySessionProps} from './types';
import {formatPrice} from 'presentation/utils';

const {serviceDate, sessionValue} = translations['pt-br'].privateFlow.refund.therapies;

const ReadOnlySession: React.FC<ReadOnlySessionProps> = ({sessionData}) => {
	const theme = useTheme();

	return (
		<Stack direction="row" spacing={2}>
			<Stack direction="row" spacing={1.5} flex={1} alignItems="center">
				<Icon name="event-filled" size={20} color={theme.palette.primary.main} />
				<Stack>
					<Typography variant="body2" color="text.secondary">
						{serviceDate}
					</Typography>
					<Typography variant="body1" color="text.primary">
						{sessionData?.serviceDate || '-'}
					</Typography>
				</Stack>
			</Stack>
			<Stack direction="row" spacing={1.5} flex={1} alignItems="center">
				<Icon name="attach-money-filled" size={20} color={theme.palette.primary.main} />
				<Stack>
					<Typography variant="body2" color="text.secondary">
						{sessionValue}
					</Typography>
					<Typography variant="body1" color="text.primary">
						{sessionData?.sessionValue ? formatPrice(sessionData.sessionValue) : '-'}
					</Typography>
				</Stack>
			</Stack>
		</Stack>
	);
};

export {ReadOnlySession};
